module.exports = __webpack_public_path__ + "client/fonts/glyphicons-halflings-regular.woff2";